import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import ClubGallery from "@/components/sections/ClubGallery";
import Differentiator from "@/components/sections/Differentiator";
import StaffGrid from "@/components/sections/StaffGrid";
import Trophies from "@/components/sections/Trophies";
import FeaturedProducts from "@/components/sections/FeaturedProducts";
import ContactSection from "@/components/sections/ContactSection";
import useSEO, { BASE_URL, DEFAULT_OG_IMAGE } from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "C.D. La Bombonera de Barcelona · Club Deportivo desde 2015",
    description:
      "Club Deportivo La Bombonera de Barcelona. Desde 2015 elegimos el deporte como estilo de vida: palmarés, equipo, tienda oficial y contacto. Hacete socio.",
    canonical: `${BASE_URL}/`,
    image: DEFAULT_OG_IMAGE,
  });

  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <ClubGallery />
      <Differentiator />
      <StaffGrid />
      <Trophies />
      <FeaturedProducts />
      <ContactSection />
    </main>
  );
}
